import { Box, Checkbox, Divider } from '@factorialco/deprecated-design-system'
import type { ExportsExporterQuery } from 'generated/resources/graphql'
import { keyBy } from 'lodash'

type UniversalExportsExporterExtraOption =
  ExportsExporterQuery['universalExports']['exportersConnection']['nodes'][number]['extraOptions'][number]

import { useFormContext } from 'modules/core/hooks/useForm'

import type { ConfigurationFormValues } from 'modules/universal_exports/components/ExportSidepanel/types'

interface Props {
  exporterOptions: UniversalExportsExporterExtraOption[]
}

const ExtraOptions = ({ exporterOptions }: Props) => {
  const { values, setFieldValue } = useFormContext<ConfigurationFormValues>()

  const optionsByName = keyBy(exporterOptions, 'name')

  return (
    <>
      <Divider />
      <Box flexDirection="column" gap="s8">
        {values.extraOptions.map((extraOption, index) => (
          <Checkbox
            key={extraOption.name}
            size="medium"
            label={optionsByName[extraOption.name]?.label}
            onChange={(event) =>
              setFieldValue(`extraOptions.${index}`, {
                ...extraOption,
                value: event.target.checked,
              })
            }
            value={extraOption.name}
            checked={extraOption.value}
          />
        ))}
      </Box>
    </>
  )
}

export default ExtraOptions
